import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Globe, Clock, Money } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'

interface InstructionProps {
  iconName: string
  description: string
  isLoading?: boolean
}

export const Instruction: React.FC<InstructionProps> = ({
  iconName,
  description,
  isLoading = false,
}) => {
  const theme = useTheme()

  const renderIcon = () => {
    const iconProps = {
      size: 24,
      color: theme.colors.icon?.activeInputIcon || theme.colors.label.primary,
    }

    switch (iconName) {
      case 'global':
        return <Globe {...iconProps} />
      case 'clock':
        return <Clock {...iconProps} />
      case 'interest':
        return <Money {...iconProps} />
      default:
        return <Money {...iconProps} />
    }
  }

  if (isLoading) {
    return (
      <BaseView row gap={12} align="flex-start">
        {/* Icon skeleton */}
        <BaseView
          circle
          circleSize={40}
          center
          style={{
            backgroundColor: theme.colors.background?.cardItemRoot || '#2A2A2E',
          }}
        >
          <div className="bg-gray-300 animate-pulse w-6 h-6 rounded" />
        </BaseView>

        {/* Text skeleton */}
        <BaseView flex={1}>
          <div className="bg-gray-300 animate-pulse h-4 rounded w-3/4 mb-2" />
          <div className="bg-gray-300 animate-pulse h-4 rounded w-1/2" />
        </BaseView>
      </BaseView>
    )
  }

  return (
    <BaseView row gap={12} align="flex-start">
      {/* Icon container */}
      <BaseView
        circle
        circleSize={46}
        center
        style={{
          backgroundColor: theme.colors.background?.cardItemRoot || '#2A2A2E',
        }}
      >
        {renderIcon()}
      </BaseView>

      {/* Description */}
      <BaseView flex={1}>
        <BaseText
          fontSize={16}
          fontFamily="regular"
          color="label.default"
          style={{
            lineHeight: '22px',
          }}
        >
          {description}
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
